// THIS COMPONENT WAS COPIED FROM src/components/graphics

import React from 'react';
import styled, { keyframes } from 'styled-components';
import RSVPImg from '../../images/rsvp.jpg';

const Animation = keyframes`
  0%   {background-position: top center}
  15% { background-position: bottom center;}
  50% { background-position: bottom center;}
  65% { background-position: top center;}
  100% { background-position: top center;}
`;

const RSVPGraphicWrapper = styled.div`
  margin: 0 auto;
  max-width: 340px;
  overflow: hidden;
  width: 100%;
`;

const RSVPGraphicInner = styled.div`
  animation: ${Animation} 7s infinite;
  background: url(${RSVPImg}) top center no-repeat;
  background-size: 100% auto;
  border: 1px solid #e2e2e2;
  height: 480px;
  width: 100%;
`;

export default function RSVPGraphic() {
  return (
    <RSVPGraphicWrapper>
      <RSVPGraphicInner />
    </RSVPGraphicWrapper>
  );
}
RSVPGraphic.displayName = 'RSVPGraphic';
